export default "__VITE_ASSET__DvMMbEF5__"